// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"vb_a bhs_ke","BrandListItem__name":"vb_b bhs_vp"};